import { CardsIconCarouselProps } from 'components/Cards/CardsIcon/CardsIconCarousel';
import { CardsImageCarouselProps } from 'components/Cards/CardsImage/CardsImageCarousel';
import { ContentBlockProps } from 'components/ContentBlock/types';
import { AccordionFullProps } from 'components/AccordionFull/types';
import { AnimatedMarqueeProps } from 'components/AnimatedMarquee/types';
import { ArticleGridProps } from 'components/ArticleGrid/types';
import { BentoBoxProps } from 'components/BentoBox/types';
import { CalloutGridProps, CalloutGridCardProps } from 'components/CalloutGrid/types';
import { CalloutIconProps, CalloutImageProps } from 'components/Callouts/types';
import { CanvasNavProps, CanvasNavItemProps } from 'components/CanvasNav/types';
import { CardsGridComplexProps } from 'components/Cards/CardsGridComplex/types';
import { CardsGridSimpleProps } from 'components/Cards/CardsGridSimple/types';
import { CardsExpandableProps } from 'components/Cards/CardsExpandable/types';
import { CardsStackedProps } from 'components/CardsStacked/types';
import { CompareProps } from 'components/Compare/types';
import { CrossSellProps } from 'components/shared/CrossSell/types';
import { CtaAddOnProps } from 'components/CtaAddOn/types';
import { DisclosureAddOnProps } from 'components/DisclosureAddOn/types';
import { DisclosureBannerProps } from 'components/DisclosureBanner/types';
import { DisclosureCollectionProps } from 'components/DisclosureCollection/types';
import { DisclosureGroupingsProps } from 'components/DisclosureGroupings/types';
import { ExplainerProps } from 'components/Explainer/types';
import { FaqProps } from 'components/Faq/types';
import { FeaturedBannerProps } from 'components/FeaturedBanner/types';
import { FeaturedJobsProps } from 'components/FeaturedJobs/types';
import { FeaturesProps } from 'components/Features/types';
import { FooterProps } from 'components/Footer/types';
import { FullBleedImageHeadlineProps } from 'components/FullBleedImageHeadline/types';
import { FullWidthImageProps } from 'components/FullWidthImage/types';
import { HeaderCtaProps } from 'components/HeaderCTA/types';
import { HeaderLogoProps } from 'components/HeaderLogo/types';
import { HeadlineWithEyebrowProps } from 'components/HeadlineWithEyebrow/types';
import { HubSpotProps } from 'components/HubSpot/types';
import { ImpactHeadlineProps } from 'components/ImpactHeadline/types';
import { KeylineProps } from 'components/Keyline/types';
import { LaunchpadProps } from 'components/Launchpad/types';
import { MainNavProps } from 'components/MainNav/types';
import { MapLocatorProps } from 'components/MapLocator/types';
import { MediaCopyProps } from 'components/MediaCopy/types';
import { MediaCopyDividedProps } from 'components/MediaCopyDivided/types';
import { NoteProps } from 'components/Note/types';
import { PageSectionProps } from 'components/PageSection/types';
import { ResourcesProps } from 'components/Resources/types';
import { RichTextEditorProps } from 'components/TextEditor/types';
import { SectionBannerProps } from 'components/SectionBanner/types';
import { SectionDisclosuresProps } from 'components/SectionDisclosures/types';
import { SectionFooterProps } from 'components/SectionFooter/types';
import { SectionHeroProps } from 'components/SectionHero/types';
import { SectionNavigationProps } from 'components/SectionNavigation/types';
import { StatsigVariantContainerProps } from 'components/StatsigVariantContainer/types';
import { SubnavProps } from 'components/Subnav/types';
import { TeaserLinksProps } from 'components/TeaserLinks/types';
import { TestimonialProps } from 'components/Testimonial/types';
import { HeroConsolidatedProps } from 'components/HeroConsolidated/types';
import { HeroCarouselProps } from 'components/HeroConsolidated/Carousel/types';
import { HomepageHeroProps } from 'components/HomepageHero/types';
import { CardCarouselProps } from 'components/CardCarousel/types';
import { ContentFeatureCarouselProps } from '@/components/ContentFeatureCarousel/types';
import { CardsVerticalScrollProps } from '@/components/CardsVerticalScroll/types';

// Module type names — the __typename of the ContentfulModule used to dispatch
// rendering through `libs/experimentation/moduleRegistry`.
export type ModuleTypeName =
  | 'Accordion'
  | 'AnimatedMarquee'
  | 'ArticleGrid'
  | 'BentoBox'
  | 'CalloutGrid'
  | 'CalloutGridCard'
  | 'CalloutImage'
  | 'CalloutIcon'
  | 'CanvasNav'
  | 'CanvasNavItem'
  | 'CardsGridComplex'
  | 'CardsGridSimple'
  | 'CardCarousel'
  | 'CardsIcon'
  | 'CardsImage'
  | 'CardsStacked'
  | 'CardsExpandable'
  | 'CardsVerticalScroll'
  | 'Compare'
  | 'CopyAddOnWithButton'
  | 'ContentBlock'
  | 'ContentFeatureCarousel'
  | 'CrossSell'
  | 'DisclosureAddOn'
  | 'DisclosureBanner'
  | 'DisclosureCollection'
  | 'DisclosureGroupings'
  | 'Explainer'
  | 'Faq'
  | 'FeaturedBanner'
  | 'FeaturedJobs'
  | 'Features'
  | 'FullBleedImageHeadline'
  | 'FullWidthImage'
  | 'HeaderCta'
  | 'HeaderLogo'
  | 'HeadlineWithEyebrow'
  | 'HeroCarousel'
  | 'HeroConsolidated'
  | 'HomepageHero'
  | 'HubSpot'
  | 'ImpactHeadline'
  | 'Keyline'
  | 'Launchpad'
  | 'MapLocator'
  | 'MediaCopy'
  | 'MediaCopyDivided'
  | 'Nav'
  | 'Note'
  | 'PageSection'
  | 'SectionHero'
  | 'SectionDisclosures'
  | 'SectionFooter'
  | 'SectionNavigation'
  | 'SectionBanner'
  | 'StatsigVariantContainer'
  | 'ResourcesItgBranded'
  | 'RichTextEditor'
  | 'TextEditor'
  | 'SiteFooter'
  | 'Subnav'
  | 'Testimonial'
  | 'TeaserLinks';

// This is a mapping of module names to their corresponding props.
export type ModuleProps = {
  Accordion: AccordionFullProps;
  AnimatedMarquee: AnimatedMarqueeProps;
  ArticleGrid: ArticleGridProps;
  BentoBox: BentoBoxProps;
  CalloutGrid: CalloutGridProps;
  CalloutGridCard: CalloutGridCardProps;
  CalloutImage: CalloutImageProps;
  CalloutIcon: CalloutIconProps;
  CanvasNav: CanvasNavProps;
  CanvasNavItem: CanvasNavItemProps;
  CardCarousel: CardCarouselProps;
  CardsGridComplex: CardsGridComplexProps;
  CardsGridSimple: CardsGridSimpleProps;
  CardsStacked: CardsStackedProps;
  CardsIcon: CardsIconCarouselProps;
  CardsImage: CardsImageCarouselProps;
  CardsVerticalScroll: CardsVerticalScrollProps;
  Compare: CompareProps;
  CopyAddOnWithButton: CtaAddOnProps;
  ContentBlock: ContentBlockProps;
  ContentFeatureCarousel: ContentFeatureCarouselProps;
  CrossSell: CrossSellProps;
  DisclosureAddOn: DisclosureAddOnProps;
  DisclosureBanner: DisclosureBannerProps;
  DisclosureCollection: DisclosureCollectionProps;
  DisclosureGroupings: DisclosureGroupingsProps;
  Explainer: ExplainerProps;
  Faq: FaqProps;
  FeaturedBanner: FeaturedBannerProps;
  FeaturedJobs: FeaturedJobsProps;
  Features: FeaturesProps;
  FullBleedImageHeadline: FullBleedImageHeadlineProps;
  FullWidthImage: FullWidthImageProps;
  HeaderCta: HeaderCtaProps;
  HeaderLogo: HeaderLogoProps;
  HeadlineWithEyebrow: HeadlineWithEyebrowProps;
  HeroCarousel: HeroCarouselProps;
  HeroConsolidated: HeroConsolidatedProps;
  HomepageHero: HomepageHeroProps;
  HubSpot: HubSpotProps;
  ImpactHeadline: ImpactHeadlineProps;
  Keyline: KeylineProps;
  Launchpad: LaunchpadProps;
  MapLocator: MapLocatorProps;
  MediaCopy: MediaCopyProps;
  MediaCopyDivided: MediaCopyDividedProps;
  Nav: MainNavProps;
  Note: NoteProps;
  PageSection: PageSectionProps;
  SectionHero: SectionHeroProps;
  SectionDisclosures: SectionDisclosuresProps;
  SectionFooter: SectionFooterProps;
  SectionNavigation: SectionNavigationProps;
  SectionBanner: SectionBannerProps;
  StatsigVariantContainer: StatsigVariantContainerProps;
  ResourcesItgBranded: ResourcesProps;
  RichTextEditor: RichTextEditorProps;
  TextEditor: RichTextEditorProps;
  SiteFooter: FooterProps;
  Subnav: SubnavProps;
  TeaserLinks: TeaserLinksProps;
  Testimonial: TestimonialProps;
  CardsExpandable: CardsExpandableProps;
};

export type ModuleTypes = {
  [K in ModuleTypeName]: ModuleProps[K];
};

/**
 * Module type names that participate in `ModuleLists` filtering. Excludes:
 * - `CalloutGridCard` and `StatsigVariantContainer` (composed inside other modules)
 *
 * The compile-time check below fails if a new `ModuleTypeName` is added without
 * being listed here.
 */
const LISTED_MODULE_TYPE_NAMES = [
  'Accordion',
  'AnimatedMarquee',
  'ArticleGrid',
  'BentoBox',
  'CalloutGrid',
  'CalloutImage',
  'CalloutIcon',
  'CanvasNav',
  'CardsImage',
  'CardsIcon',
  'CardsExpandable',
  'CardCarousel',
  'CardsGridComplex',
  'CardsGridSimple',
  'CardsStacked',
  'CardsVerticalScroll',
  'Compare',
  'CopyAddOnWithButton',
  'ContentBlock',
  'ContentFeatureCarousel',
  'CrossSell',
  'DisclosureAddOn',
  'DisclosureBanner',
  'DisclosureCollection',
  'DisclosureGroupings',
  'Explainer',
  'Faq',
  'FeaturedBanner',
  'FeaturedJobs',
  'Features',
  'FullBleedImageHeadline',
  'FullWidthImage',
  'HeaderCta',
  'HeaderLogo',
  'HeadlineWithEyebrow',
  'HeroCarousel',
  'HeroConsolidated',
  'HomepageHero',
  'HubSpot',
  'ImpactHeadline',
  'Keyline',
  'Launchpad',
  'MapLocator',
  'MediaCopy',
  'MediaCopyDivided',
  'Nav',
  'Note',
  'PageSection',
  'ResourcesItgBranded',
  'RichTextEditor',
  'TextEditor',
  'SectionHero',
  'SectionDisclosures',
  'SectionFooter',
  'SectionNavigation',
  'SectionBanner',
  'SiteFooter',
  'Subnav',
  'TeaserLinks',
  'Testimonial',
] as const satisfies readonly ModuleTypeName[];

// Exhaustiveness check: errors if a new `ModuleTypeName` is added without being
// listed above (or explicitly excluded as non-listed).
type _ListedModuleExhaustivenessCheck =
  Exclude<
    ModuleTypeName,
    (typeof LISTED_MODULE_TYPE_NAMES)[number] | 'CalloutGridCard' | 'CanvasNavItem' | 'StatsigVariantContainer'
  > extends never
    ? true
    : never;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _listedModuleExhaustivenessCheck: _ListedModuleExhaustivenessCheck = true;

export enum ModuleList {
  ALL = 'All',
  HEADER_BANNER = 'HeaderBanner',
  HEADER = 'Header',
  MAIN = 'Main',
  BLOG_POST_MAIN = 'BlogPostMain',
  BLOG_POST_SIDEBAR = 'BlogPostSidebar',
  BLOG_POST_BOTTOM = 'BlogPostBottom',
  CAREER_TEMPLATE_MAIN = 'CareerTemplateMain',
  FLEXIBLE_BLOG_POST_MAIN = 'FlexibleBlogPostMain',
  FLEXIBLE_BLOG_POST_SIDEBAR = 'FlexibleBlogPostSidebar',
  FLEXIBLE_BLOG_POST_BOTTOM = 'FlexibleBlogPostBottom',
  FOOTER = 'Footer',
  DISCLOSURES = 'Disclosures',
}

export type ModuleListType = {
  [key in ModuleList]: ModuleTypeName[];
};

const FEATURED_BANNER_MODULES: ModuleTypeName[] = ['FeaturedBanner', 'HeaderLogo', 'SectionBanner'];
const HEADER_MODULES: ModuleTypeName[] = ['Nav', 'HeaderCta', 'SectionNavigation'];
const FOOTER_MODULES: ModuleTypeName[] = ['SiteFooter', 'SectionFooter'];
const DISCLOSURES_MODULES: ModuleTypeName[] = ['DisclosureGroupings', 'DisclosureBanner', 'SectionDisclosures'];
const BLOG_POST_MAIN_MODULES: ModuleTypeName[] = [
  'Faq',
  'Keyline',
  'MediaCopy',
  'PageSection',
  'RichTextEditor',
  'TeaserLinks',
  'Testimonial',
  'TextEditor',
];
const BLOG_POST_SIDEBAR_MODULES: ModuleTypeName[] = ['CrossSell'];
const BLOG_POST_BOTTOM_MODULES: ModuleTypeName[] = ['TeaserLinks', 'ArticleGrid'];

// Career modules
const CAREER_TEMPLATE_MAIN_MODULES: ModuleTypeName[] = ['ContentBlock', 'Faq', 'MediaCopy'];

// Flexible Blog Post modules
const FLEXIBLE_BLOG_POST_MAIN_MODULES: ModuleTypeName[] = [
  'CopyAddOnWithButton',
  'Faq',
  'Keyline',
  'MediaCopy',
  'PageSection',
  'RichTextEditor',
  'TeaserLinks',
  'TextEditor',
  'Note',
];
const FLEXIBLE_BLOG_POST_SIDEBAR_MODULES: ModuleTypeName[] = ['CrossSell'];
const FLEXIBLE_BLOG_POST_BOTTOM_MODULES: ModuleTypeName[] = [
  'Faq',
  'ContentBlock',
  'ArticleGrid',
  'HubSpot',
  'Testimonial',
  'TeaserLinks',
];

// Main modules are all modules that are not in the header, footer, or disclosures lists.
const MAIN_MODULES = LISTED_MODULE_TYPE_NAMES.filter(
  module =>
    ![...FEATURED_BANNER_MODULES, ...HEADER_MODULES, ...FOOTER_MODULES, ...DISCLOSURES_MODULES].includes(module),
) as ModuleTypeName[];

// Provides a list of modules that are allowed to be rendered in a given list.
export const ModuleLists: ModuleListType = {
  All: [...LISTED_MODULE_TYPE_NAMES],
  HeaderBanner: FEATURED_BANNER_MODULES,
  Header: HEADER_MODULES,
  Main: MAIN_MODULES,
  BlogPostMain: BLOG_POST_MAIN_MODULES,
  BlogPostSidebar: BLOG_POST_SIDEBAR_MODULES,
  BlogPostBottom: BLOG_POST_BOTTOM_MODULES,
  CareerTemplateMain: CAREER_TEMPLATE_MAIN_MODULES,
  FlexibleBlogPostMain: FLEXIBLE_BLOG_POST_MAIN_MODULES,
  FlexibleBlogPostSidebar: FLEXIBLE_BLOG_POST_SIDEBAR_MODULES,
  FlexibleBlogPostBottom: FLEXIBLE_BLOG_POST_BOTTOM_MODULES,
  Footer: FOOTER_MODULES,
  Disclosures: DISCLOSURES_MODULES,
};

/**
 * Checks if a module is a valid module type for a given list.
 * @param item - The module to check.
 * @param list - The list to check against.
 * @returns True if the module is a valid module type for the given list, false otherwise.
 */
export const isMappedModule = (item: ModuleTypes[ModuleTypeName], list: ModuleList = ModuleList.ALL) =>
  ModuleLists[list].includes(item.__typename as ModuleTypeName);

export { ENTRY_NATIVE_TYPENAMES } from './entryNativeTypenames';
